import { useEffect, useState } from "react";

/**
 * Reflete `prefers-reduced-motion` do SO, reagindo a troca ao vivo — não só
 * lido uma vez. `ExedyMascot.tsx` (removido na #1044) e `SettingsShell.tsx` reimplementavam essa
 * leitura cada um do seu jeito: um assinava `change` e re-renderizava (o
 * comportamento certo), o outro só lia `matchMedia(...).matches` no instante
 * do clique/scroll, então quem trocasse a preferência do SO com a tela de
 * settings aberta via um componente atualizar e o outro não. Mesmo padrão
 * de `useIsMobile` (`use-mobile.tsx`), só que para este media query.
 */
export function usePrefersReducedMotion(): boolean {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setPrefersReducedMotion(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return prefersReducedMotion;
}
